export const templateTypeDataSource = [
  { name: "Стандарт", id: 0 },
  { name: "Авиа", id: 1 },
];
